<template>
  <div>
    <h1>{{ subSectionData.internal_name_es }}</h1>
    <span v-html="subSectionData.desc_sub_section_es"></span>
  </div>
</template>

<script>
export default {
  name: 'SubSectionStandartHead',
  props: ['subSectionData'],
};
</script>
